import React from 'react';
import { Box, Button, CircularProgress, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import FotoUpload from '../components/FotoUpload';
import SimpleSnackbar from '../../ui/SimpleSnackbar';
import CostActionBarMenu from '../components/CostActionBarMenu';
import theme from '../../../themes/theme';
import ReceiptForm from './ReceiptForm';
import useReceiptForm from './useReceiptForm';

function ReceiptFormMobile({ id, costCentreList, costObjectList }) {
    const form = useReceiptForm({ id, costCentreList, costObjectList });
    const {
        imageUrlLocal,
        setImageUrlLocal,
        setFile,
        isPdf,
        setIsPdf,
        message,
        setMessage,
        userAccess,
        loading,
        receipt,
        costCentre,
        costObject,
        handleSubmit,
        handleEditCreateReceipt,
        checkCostCentre,
        checkCostObject,
    } = form;
    const { t } = useTranslation();

    if (receipt?.logbookReceipts[0]?.articles[0]?.costCentre && costCentre.length > 0) {
        checkCostCentre(costCentreList, costCentre);
    }

    if (receipt?.logbookReceipts[0]?.articles[0]?.costObject && costObject.length > 0) {
        checkCostObject(costObjectList, costObject);
    }

    return (
        <Box
            sx={{
                position: 'absolute',
                inset: 0,
                width: '100vw',
                height: '100vh',
                overflow: 'scroll',
                bgcolor: '#FAFAFA',
                zIndex: theme.zIndex.drawer + 1,
            }}
        >
            <Stack
                direction='row'
                alignItems='center'
                justifyContent='space-between'
                sx={{
                    height: '56px',
                    position: 'sticky',
                    top: '0',
                    bgcolor: '#FAFAFA',
                    zIndex: theme.zIndex.drawer + 2,
                }}
            >
                <Stack direction='row'>
                    <Button onClick={handleEditCreateReceipt}>
                        <CloseIcon sx={{ color: 'black' }} />
                    </Button>
                </Stack>
                {loading && !id ? (
                    <CircularProgress size='24px' sx={{ marginRight: '32px' }} color='primary' />
                ) : (
                    userAccess < 3 && (
                        <Box display={'flex'} paddingRight={'24px'}>
                            <Button onClick={(e) => handleSubmit(e)}>{id ? t('update') : t('save')}</Button>
                            {id && <CostActionBarMenu id={id} />}
                        </Box>
                    )
                )}
            </Stack>
            <Stack spacing={1} alignItems='center'>
                <FotoUpload
                    imageUrlLocal={imageUrlLocal}
                    setImageUrlLocal={setImageUrlLocal}
                    setFile={setFile}
                    id={id}
                    isPdf={isPdf}
                    setIsPdf={setIsPdf}
                />
                <Stack
                    sx={{
                        width: '328px',
                        marginInline: 'auto',
                        bgcolor: 'white',
                        borderRadius: '12px',
                        border: '1px solid #E0E0E0',
                        padding: '24px 16px',
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                    }}
                >
                    <Stack spacing={4} justifyContent='center' alignItems='center'>
                        <ReceiptForm
                            form={form}
                            id={id}
                            variant='mobile'
                            costCentreList={costCentreList}
                            costObjectList={costObjectList}
                        />
                    </Stack>
                </Stack>
            </Stack>
            {message && <SimpleSnackbar message={message} setMessage={setMessage} />}
        </Box>
    );
}

export default ReceiptFormMobile;
